/**
 * Admin service for managing credit packages
 */
import api from './api';

export interface CreditPackage {
  id: string;
  name: string;
  description?: string;
  credits: number;
  bonus_credits: number;
  price_cents: number;
  currency: string;
  is_active: boolean;
  is_popular: boolean;
  sort_order: number;
  stripe_price_id?: string;
  stripe_product_id?: string;
  created_at: string;
  updated_at: string;
  price_dollars: number;
  total_credits: number;
  credits_per_dollar: number;
}

export interface CreditPackageCreate {
  name: string;
  description?: string;
  credits: number;
  bonus_credits?: number;
  price_cents: number;
  currency?: string;
  is_active?: boolean;
  is_popular?: boolean;
  sort_order?: number;
}

export interface CreditPackageUpdate {
  name?: string;
  description?: string;
  credits?: number;
  bonus_credits?: number;
  price_cents?: number;
  currency?: string;
  is_active?: boolean;
  is_popular?: boolean;
  sort_order?: number;
}

class AdminCreditPackageService {
  /**
   * Get all credit packages
   */
  async getCreditPackages(isActive?: boolean): Promise<CreditPackage[]> {
    const params = isActive !== undefined ? { is_active: isActive } : {};
    const response = await api.get('/admin/credit-packages', { params });
    return response.data;
  }

  /**
   * Create a new credit package
   */
  async createCreditPackage(data: CreditPackageCreate): Promise<CreditPackage> {
    const response = await api.post('/admin/credit-packages', data);
    return response.data;
  }

  /**
   * Update a credit package
   */
  async updateCreditPackage(id: string, data: CreditPackageUpdate): Promise<CreditPackage> {
    const response = await api.put(`/admin/credit-packages/${id}`, data);
    return response.data;
  }

  /**
   * Delete a credit package
   */
  async deleteCreditPackage(id: string): Promise<void> {
    await api.delete(`/admin/credit-packages/${id}`);
  }
}

export default new AdminCreditPackageService();
